import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/system";
import { Close } from "@mui/icons-material";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import {
  useDeleteVibeMutation,
  useGetVibesQuery,
} from "../../Slices/roomNateApis";
import AddVibeModal from "./AddVibeModal";
import ViewVibeModal from "./ViewVibeModal";
import UpdateVibeModal from "./UpdateVibeModal";

export default function BasicTable({ FetchStyles }) {
  const [selectedId, setSelectedId] = React.useState();

  const [open, setOpen] = React.useState(false);
  const { data: FetchVibes, isLoading } = useGetVibesQuery();
  const [deleteVibe, resultStats] = useDeleteVibeMutation();
  const [successAlert, setSuccessAlert] = React.useState(false);
  const [errorAlert, setErrorAlert] = React.useState(false);

  const [selectedStyle, setSelectedStyle] = React.useState(null);

  const filteredData = FetchVibes?.filter((item) => {
    if (!selectedStyle) {
      return true;
    }
    if (selectedStyle) {
      if (item.style.toLowerCase().includes(selectedStyle?._id.toLowerCase())) {
        return true;
      }
    }
    return false;
  });

  const handleClickOpen = (id) => {
    setOpen(true);
    setSelectedId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (
      resultStats?.error?.data == "Vibe deleted successfully" &&
      selectedId &&
      resultStats?.isError
    ) {
      setSuccessAlert(true);
      setTimeout(() => {
        setSuccessAlert(false);
      }, 2000);
    }

    if (
      resultStats?.error?.data != "Vibe deleted successfully" &&
      selectedId &&
      resultStats?.isError
    ) {
      setErrorAlert(true);
      setTimeout(() => {
        setErrorAlert(false);
      }, 2000);
    }
  }, [resultStats, selectedId]);

  const handleDelete = () => {
    handleClose();
    deleteVibe(selectedId);
    setOpen(false);
  };

  return (
    <>
      {successAlert && (
        <SuccessAlert title="Vibe has been deleted successfully!" />
      )}

      {errorAlert && <ErrorAlert title="Something Went Wrong!" />}

      <TableContainer component={Paper}>
        <Box sx={{ pt: 2, px: 2 }}>
          <Typography variant="h6" component={"h6"} flexGrow={1}>
            Search Filter
          </Typography>
          <Grid container spacing={2} style={{ marginTop: "0px" }}>
            {FetchStyles && (
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  disablePortal
                  onChange={(event, value) => setSelectedStyle(value)}
                  name={`style`}
                  id="combo-box-demo"
                  options={FetchStyles}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      placeholder={"Select Style"}
                      name={`style`}
                      {...params}
                    />
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: 2,
            px: 2,
          }}
        >
          <Typography variant="h6" component={"h6"} flexGrow={1}>
            Vibes
          </Typography>

          <AddVibeModal FetchStyles={FetchStyles} />
        </Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={4}>Loading...</TableCell>
              </TableRow>
            )}

            {!isLoading && filteredData?.length > 0 ? (
              filteredData?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell>
                    {row.midJourneyPrompt?.length > 30
                      ? row.midJourneyPrompt.substr(0, 30) + "..."
                      : row.midJourneyPrompt}
                  </TableCell>

                  <TableCell align="center">
                    <>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => handleClickOpen(row._id)}
                          color="primary"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                      <Dialog
                        maxWidth="sm"
                        fullWidth
                        open={open}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title">
                          {"Confirm the Action?"}
                        </DialogTitle>
                        <Box position="absolute" top={10} right={0}>
                          <IconButton onClick={handleClose}>
                            <Close />
                          </IconButton>
                        </Box>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            Do you really want to delete the vibe?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleClose} variant="outlined">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => handleDelete(row._id)}
                            variant="contained"
                            autoFocus
                          >
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </>
                    <ViewVibeModal item={row} FetchStyles={FetchStyles} />
                    <UpdateVibeModal item={row} FetchStyles={FetchStyles} />
                  </TableCell>
                </TableRow>
              ))
            ) : !isLoading && filteredData?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>No Record !</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
